<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/layoutComponents/page-header'
import Table from '../../components/common/table/Table'
import TableHeader from '../../components/common/table/TableHeader'
import Pagination from '../../components/common/table/Pagination.vue'
import listDataProvider from '../../services/list'
import { invoiceMixins, ListsMixins, urlQueriesMixins } from '../../utils/mixins'
import Loader from '../../components/common/loader.vue'
import Excel from '../common/excel.vue'
import axios from 'axios'
import { API_URL } from '../../../config/HTTP.js'
import Toast from '../common/Toast.vue'
import walletDataProvider from '../../services/wallet'
import IvitationSetting from '../user/invitation/SettingModal'
import BlackListModal from '../user/invitation/BlackListModal'
import notificationsDataProvider from '../../services/notifications'
import CommentsSideCard from '../../components/comment/SideCard'
import dadbanPackageProvider from '../../services/dadban/package'
import dadbanCourseProvider from '../../services/dadban/course'
import moocCategoryProvider from '../../services/mooc/category'
import skillUpCategoryProvider from '../../services/skillUp/category'
import dadbananSettingProvider from '../../services/dadban/banners'
import skillUpUsersProvider from '../../services/skillUp/user'
import moocUsersProvider from '../../services/mooc/user'
import moocPackageProvider from '../../services/mooc/package'
import dadbanDiscountProvider from '../../services/dadban/discount'
import AddCategory from '../mooc/categoury/AddCategory.vue'
import TeacherValidationModal from '../mooc/teachers/ValidationModal.vue'
import SkillUpTeacherValidationModal from '../skillup/teachers/ValidationModal.vue'
import Reporting from '../mooc/reporting/Reporting.vue'
import HomeCategoryModal from '../dadban/banners/HomeCategoryModal.vue'
import moocCourseProvider from '../../services/mooc/course'
import skillUpSupplierProvider from '../../services/skillUp/suppliers'
import Category from '../skillup/category/Category.vue'
import skillUpCourseProvider from '../../services/skillUp/course'
import skillUpPackageProvider from '../../services/skillUp/package'
import skillUpDiscountProvider from '../../services/skillUp/discount'
import skillUpBannerProvider from '../../services/skillUp/banner'
import PartnerModal from '../skillup/partner/PartnerModal.vue'
import skillUpCertificateProvider from '../../services/skillUp/partner'

export default {
  page: {
    title: 'لیست ها',
    meta: [
      {
        name: 'list',
        content: appConfig.description,
      },
    ],
  },
  mixins: [ListsMixins, urlQueriesMixins, invoiceMixins],
  components: {
    PageHeader,
    Table,
    TableHeader,
    Pagination,
    Loader,
    Excel,
    Toast,
    IvitationSetting,
    BlackListModal,
    CommentsSideCard,
    AddCategory,
    Category,
    HomeCategoryModal,
    TeacherValidationModal,
    SkillUpTeacherValidationModal,
    Reporting,
    PartnerModal,
  },
  props: {
    checkedList: Array,
  },
  data() {
    return {
      categoryData: {},
      skillUPCategoryData: {},
      homeCategoryData: {},
      skillUpPartnerData: {},
      wannaExcel: null,
      fields: [],
      filters: [],
      rows: [],
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 20, value: 'نمایش 20 تایی', isDefault: false },
        { id: 3, count: 50, value: 'نمایش 50 تایی', isDefault: false },
      ],
      downloadLink: '',
      componentKey: 0,
      loading: false,
      tableLoading: false,
      dotLoading: false,
      staticTransactionPage: null,
      prevRoute: null,
      toastMode: null,
      toastText: '',
      showToast: null,
      toastKey: 1,
      reqResponse: null,
      IvitationSettingModel: false,
      BlackListModel: false,
      modalKey: 2,
      BlackListKey: 3,
      followUpData: [],
      list: [],
      focused: false,
      globalTableKey: '',
    }
  },

  methods: {
    onSearch(params) {
      this.getData(this.handleReporting(params))
    },
    async fetchCategory(e) {
      let result

      try {
        if (this.$route.params.slug === 'universitycategorycourse') {
          result = await moocCategoryProvider.getCategorysCourse(Number(e.id))
        } else if (this.$route.params.slug === 'universitycategorypackage') {
          result = await moocCategoryProvider.getCategorysPackage(Number(e.id))
        }
        this.categoryData = result.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSkillUpCategory(e) {
      let result
      try {
        result = await skillUpCategoryProvider.getCategoriesCourse(Number(e.id))
        this.skillUPCategoryData = result.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSkillUpPartner(e) {
      let result
      try {
        result = await skillUpCertificateProvider.getCertificate(Number(e.id))
        this.skillUpPartnerData = result.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    async fetchHomeCategory(e) {
      try {
        const result = await dadbananSettingProvider.getHomeCategory(Number(e.id))
        if (result.status === 200) this.homeCategoryData = result.data.data.output
      } catch (error) {
        return false
      }
    },
    rowSelected(e) {
      const route = this.$route

      if (['universitycategorypackage', 'universitycategorycourse'].includes(route.params.slug)) {
        this.fetchCategory(e)
      }
      if (route.params.slug === 'skillupcategory') this.fetchSkillUpCategory(e)
      if (route.params.slug === 'homecategory') {
        this.fetchHomeCategory(e)
      }
      if (this.$route.params.slug === 'skillupcertificates') {
        this.fetchSkillUpPartner(e)
      }
    },
    catchErr(error) {
      // this.$router.go(-1)
      this.loading = null
      this.tableLoading = null
      this.dotLoading = null
      this.forceRerender()
      this.toastMode = true
      this.toastText = error || 'مشکلی پیش آمده است لطفا دوباره سعی کنید.'
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
        this.toastKey += 1
      }, 2000)
    },
    getData(payload, force) {
      if (this.$route.name === 'courses-package-activities' || this.$route.name === 'courses-package-course-activities') {
        return
      }
      if (this.$route.name === 'courses-package' && this.$route.query.query) {
        this.fetchCoursePackage()
      }
      if (this.$route.name === 'comments-courses') {
        this.handleCourseComments(this.$route)
      }
      if (this.$route.name === 'comments-packages') {
        this.handlePackageComments(this.$route)
      }
      if (this.$route.name === 'course-courseadminstudents' || this.$route.name === 'package-packageadminstudents') {
        this.handleStudent()
      }

      if (this.$route.name === 'package-prerequisites' && this.$route.query.query) {
        this.fetchPackagePrerequisites()
      }
      if (this.$route.name === 'course-prerequisites' && this.$route.query.query) {
        if (this.$route.path.includes('skillup')) this.fetchSkillUpCoursePrerequisites()
        else this.fetchCoursePrerequisites()
      }
      if (this.$route.name === 'course-users') {
        this.fetchSearchUsers()
      }

      if (this.$route.name === 'course-users') {
        payload = this.handleCourseUsers()
      }

      if (force) {
        payload = this.handleCourseUsers(force)
      }

      if (this.$route.name === 'transactions-fromUserManagement') {
        walletDataProvider
          .getSpecificUserWalletTransactionsFromUsermanagement(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else if (this.$route.path.includes('teacherskilluppractice')) {
        const route = this.$route
        let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
        let pageSize = route.query.perPage ? route.query.perPage : 10
        const query = localStorage.getItem('courseName')

        const params = {
          key: 'teacherskilluppractice',
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize),
          query: query,
        }
        listDataProvider.getListData(params).then((res) => {
          this.reqResponse = res.data
          this.manageData()
          localStorage.removeItem('courseName')
        })
      } else if (this.$route.name === 'transactions-fromListsWallet') {
        walletDataProvider
          .getSpecificUserWalletTransactionsFromListsWallet(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        dadbanDiscountProvider
          .getProductsTable(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
        skillUpDiscountProvider
          .getProductsTable(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else {
        listDataProvider
          .getListData(payload)
          .then((res) => {
            this.reqResponse = res.data

            this.globalTableKey = res.data.data.addRowPage.key
            // this.reqResponse.data.addRowPage.key = 'invitation'
            // this.reqResponse.data.addRowPage.link = 'invitation'
            this.manageData()
          })
          .catch((err) => {
            if (this.$route.path !== '/list/discount') {
              this.catchErr()
            }
          })
      }
    },
    manageData() {
      this.dotLoading = true
      this.$store.dispatch('lists/setDataList', this.reqResponse)
      this.fields = this.dataList.data.fields
      this.rows = this.dataList.data.rows
      this.filters = this.dataList.data.filters
      setTimeout(() => {
        if (this.$route.name !== 'course-users') {
          this.forceRerender()
        }
        this.loading = false
        this.tableLoading = false
        this.dotLoading = false
      }, 300)
    },
    excelDownload() {
      const fields = [
        {
          fieldName: 'PackageId',
          text: this.$route.params.packageId,
        },
      ]
      this.wannaExcel = null
      axios
        .post(
          `${API_URL}/Aggregator.Crm/api/Table/ExportToXlsx`,
          {
            key: this.globalTableKey,
            query: this.searchQuery,
            pageSize: this.pageSize,
            pageNumber: this.currentPage,
            fieldSearchs: this.$route.name === 'courses-package-activities' ? fields : undefined,
          },
          { responseType: 'blob' },
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          this.downloadLink = URL.createObjectURL(blob)
        })
    },
    addRow() {
      const route = this.$route.name
      localStorage.removeItem('package')
      localStorage.removeItem('course')
      if (route === 'course-courseadminstudents' || route === 'package-packageadminstudents') {
        const product = this.$route.params.courseId ? 'course' : 'package'
        localStorage.setItem(product, this.$route.params.courseId || this.$route.params.packageId)
        this.$router.push(this.$route.path + 'add')
        return
      }
      if (['universitycategorypackage', 'universitycategorycourse'].includes(this.$route.params.slug)) {
        this.$bvModal.show('categoryModal')
      } else if (this.$route.params.slug === 'homecategory') {
        this.$bvModal.show('homeCategoryModal')
      } else if (this.$route.path.includes('/list/posts')) {
        const router = this.$router.resolve({ name: 'dadban-add-posts' })

        window.open(router.href, '_blank')
      } else if (this.$route.params.slug && this.$route.params.slug.includes('universityteachers')) {
        this.$bvModal.show('teacherValidation')
      } else if (this.$route.params.slug && this.$route.params.slug.includes('skillupcategory')) {
        this.$bvModal.show('skillUpCategoryModal')
      } else if (this.$route.params.slug && this.$route.params.slug.includes('skillupteachers')) {
        this.$bvModal.show('teacherSkillUpValidation')
      } else if (this.$route.params.slug === 'skillupcertificates') {
        this.$bvModal.show('partnerModal')
      } else {
        this.$router.push({ path: `/list/${this.dataList.data.addRowPage.key}/add` })
      }
    },
    forceRerender() {
      this.componentKey += 1
    },
    invitaionSetting($event) {
      this.IvitationSettingModel = false
      this.modalKey += 1
      notificationsDataProvider.getFollowUp().then((res) => {
        this.followUpData = res.data.data
        setTimeout(() => {
          this.IvitationSettingModel = true
          this.modalKey += 1
        }, 200)
      })
    },
    blackListSetting($event) {
      this.BlackListModel = false
      this.BlackListKey += 1
      setTimeout(() => {
        this.BlackListModel = true
        this.BlackListKey += 1
      }, 200)
    },
    handleCourseComments(route) {
      const tmp = route.name.split('-')[1]
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      let statusCode = 0
      switch (tmp) {
        case 'waiting':
          statusCode = 1
          break
        case 'approved':
          statusCode = 2
          break
        case 'failed':
          statusCode = 3
          break
      }
      const commentsObj = (statusCode) => {
        const params = {
          key: route.path.includes('list/comments') ? 'allcomments' : 'skillupcoursecomments',
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize),
          query: this.$route.query.query,
          fieldSearchs: [
            {
              fieldName: route.path.includes('list/comments') ? 'ProductType' : 'CourseId',
              type: 'string',
              text: route.path.includes('list/comments') ? '0' : route.params.courseId,
            },
            {
              fieldName: 'Status',
              type: 'string',
              text: statusCode.toString(),
            },
          ],
        }
        // if (this.$route.params.packageId) {
        //   params.key = 'packagecomments'
        // }
        return params
      }
      const queryParams = commentsObj(statusCode)
      return queryParams
    },
    handlePackageComments(route) {
      const tmp = route.name.split('-')[1]
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      let statusCode = 0
      switch (tmp) {
        case 'waiting':
          statusCode = 1
          break
        case 'approved':
          statusCode = 2
          break
        case 'failed':
          statusCode = 3
          break
      }
      const commentsObj = (statusCode) => {
        const params = {
          key: route.path.includes('list/comments') ? 'allcomments' : 'skilluppackagecomments',
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize),
          query: this.$route.query.query,
          fieldSearchs: [
            {
              fieldName: route.path.includes('list/comments') ? 'ProductType' : 'PackageId',
              type: 'string',
              text: route.path.includes('list/comments') ? '0' : route.params.packageId,
            },
            {
              fieldName: 'Status',
              type: 'string',
              text: statusCode.toString(),
            },
          ],
        }
        // if (this.$route.params.packageId) {
        //   params.key = 'packagecomments'
        // }
        return params
      }
      const queryParams = commentsObj(statusCode)
      return queryParams
    },
    handlePackegeCourses() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'skilluppackagecourses',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            type: 'string',
            text: route.params.packageId,
          },
        ],
      }
      if (route.path.includes('university')) {
        params.key = route.params.packageId ? 'universitypackagecourses' : 'packagecourses'
      }
      return params
    },
    async fetchAllActivities() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        search: route.query.query,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            type: 'string',
            text: route.params.packageId,
          },
        ],
      }
      try {
        const req = await skillUpPackageProvider.getAllActivities(params)
        this.reqResponse = req.data
        this.manageData()
      } catch (error) {
        console.log(error)
      }
    },
    async fetchCourseActivities() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        search: route.query.query,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            type: 'string',
            text: route.params.packageId,
          },
          {
            fieldName: 'CourseId',
            type: 'string',
            text: route.params.courseId,
          },
        ],
      }
      try {
        const req = await skillUpPackageProvider.getCourseActivities(params)
        this.reqResponse = req.data
        this.manageData()
      } catch (error) {
        console.log(error)
      }
    },
    handleCoursePrerequisites() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'courseskillupprerequisites',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'CourseId',
            type: 'string',
            text: route.params.courseId,
          },
        ],
      }
      return params
    },
    handleStudent() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'courseadminstudents',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'ProductId',
            type: 'string',
            text: route.params.courseId || route.params.packageId,
          },
        ],
      }
      if (route.params.packageId) params.key = 'packageadminstudents'
      return params
    },
    handleIssuanceOfACertificate() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'universitylicensepeople',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'CourseId',
            type: 'string',
            text: route.params.courseId,
          },
        ],
      }
      return params
    },
    handleSkillUpIssuanceOfACertificate() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'skilluplicensepeople',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'CourseId',
            type: 'string',
            text: route.params.courseId,
          },
        ],
      }
      return params
    },
    handlePage() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: route.params.slug,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
      }
      return params
    },
    handleHomeCategory() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: route.params.slug,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
      }
      return params
    },
    handleSlider() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: route.params.slug,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
      }
      return params
    },

    handleReporting(filters) {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      let key = route.params.slug

      let fieldSearches = []
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          const element = filters[key]
          if (element && element.length) {
            if (Array.isArray(element)) {
              fieldSearches.push({ fieldName: 'FromDate', type: 'string', text: element[0] }, { fieldName: 'ToDate', type: 'string', text: element[1] })
            } else
              fieldSearches.push({
                fieldName: key.charAt(0).toUpperCase() + key.slice(1),
                type: 'string',
                text: String(element),
              })
          }
        }
      }

      const params = {
        key: key,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: fieldSearches,
      }
      return params
    },
    handleDiscountList() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'discount',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'Status',
            type: 'string',
            text: '-1',
          },
        ],
      }
      return params
    },
    handleComments() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'totalcomments',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        filters: route.query.filters ? route.query.filters : null,
        fieldSearchs: [
          {
            fieldName: 'Status',
            text: route.query.filters ? String(route.query.filters[0].key) : '0',
          },
        ],
      }
      return params
    },
    handleDiscountDetail() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'ProductType',
            type: 'string',
            text: this.$route.query.filters ? this.$route.query.filters.join() : '-1',
          },
        ],
      }
      return params
    },
    handlePackagePrerequisites() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'packageskillupprerequisites',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            type: 'string',
            text: route.params.packageId,
          },
        ],
      }
      return params
    },
    handleCourseUsers(q) {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      const params = {
        query: q,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        key: route.params.courseId ? 'skillupcoursepeople' : 'skilluppackagepeople',
        fieldSearchs: [
          {
            fieldName: route.params.courseId ? 'CourseId' : 'PackageId',
            text: route.params.courseId || route.params.packageId,
          },
        ],
      }
      if (route.path.includes('university')) {
        params.key = route.params.courseId ? 'skillupcoursepeople' : 'skilluppackagepeople'
      }
      return params
    },
    async fetchCoursePackage() {
      let body = {
        packageId: +this.$route.params.packageId,
        query: this.$route.query.query || '',
      }
      let req
      if (this.$route.path.includes('skillup')) {
        req = await skillUpPackageProvider.searchPackageCourse(body)
        this.list = req.data.data.output
      } else if (this.$route.path.includes('university')) {
        req = await moocPackageProvider.searchPackageCourse(body)
        this.list = req.data.data.output
      } else {
        req = await dadbanPackageProvider.searchPackageCourse(body)
        this.list = req.data.data.output
      }
    },
    async fetchCoursePrerequisites() {
      const req = await dadbanCourseProvider.searchCoursePrerequisite({
        courseId: this.$route.params.courseId,
        query: this.$route.query.query || '',
      })
      this.list = req.data.data.output
    },
    async fetchSkillUpCoursePrerequisites() {
      const req = await skillUpCourseProvider.searchCoursePrerequisite({
        courseId: this.$route.params.courseId,
        query: this.$route.query.query || '',
      })
      this.list = req.data.data.output
    },
    async fetchPackagePrerequisites() {
      const req = await dadbanPackageProvider.searchPackagePrerequisite({
        packageId: this.$route.params.packageId,
        query: this.$route.query.query || '',
      })
      this.list = req.data.data.output
    },
    async fetchSearchUsers() {
      const req = await skillUpUsersProvider.getSearchUsers(
        this.$store.state.urlQueries.searchQuery ? `?keyword=${this.$store.state.urlQueries.searchQuery || ''}&pageSize=100&pageNumber=1` : '?pageSize=100&pageNumber=1',
      )
      this.list = req.data.data
    },
    async deleteRow(id) {
      // if (this.$route.params.slug === 'universitycourses') {
      //   try {
      //     const res = await moocCourseProvider.deleteCourse(id)
      //     if (res.status === 200) this.getData(this.handlePage())
      //   } catch (error) {
      //     this.catchErr('این دوره قابل حذف کردن نیست.')
      //   }
      // }
      // if (['shortuniversitypackages', 'longuniversitypackages'].includes(this.$route.params.slug)) {
      //   try {
      //     const res = await moocPackageProvider.deletePackage(id)
      //     if (res.status === 200) this.getData(this.handlePage())
      //   } catch (error) {
      //     this.catchErr('این دوره قابل حذف کردن نیست.')
      //   }
      // }
      if (['universitycategorypackage', 'universitycategorycourse'].includes(this.$route.params.slug)) {
        if (this.$route.params.slug === 'universitycategorypackage') {
          try {
            const res = await moocCategoryProvider.deleteCategoryPackage(id)
            if (res.status === 200) this.getData(this.handlePage())
          } catch (error) {
            this.catchErr('این موضوع در حال استفاده است.')
          }
        } else if (this.$route.params.slug === 'universitycategorycourse') {
          try {
            const res = await moocCategoryProvider.deleteCategoryCourse(id)
            if (res.status === 200) this.getData(this.handlePage())
          } catch (error) {
            this.catchErr('این موضوع در حال استفاده است.')
          }
        }
      }
      if (this.$route.path === '/list/skillupcategory') {
        try {
          const res = await skillUpCategoryProvider.deleteCategoryCourse(id)
          if (res.status === 200) this.getData(this.handlePage())
        } catch (error) {
          this.catchErr('این موضوع در حال استفاده است.')
        }
      }
      if (this.$route.params.slug === 'homecategory') {
        try {
          const res = await dadbananSettingProvider.deleteHomeCategory(id)
          if (res.status === 200) this.getData(this.handleHomeCategory())
        } catch (error) {
          this.catchErr('این مورد قابل حذف نیست')
        }
      }
      if (this.$route.params.slug === 'slider') {
        try {
          const res = await dadbananSettingProvider.deleteBanner(id)
          if (res.status === 200) this.getData(this.handleSlider())
        } catch (error) {
          this.catchErr('این مورد قابل حذف نیست')
        }
      }
      if (this.$route.name === 'course-prerequisites') {
        if (this.$route.path.includes('skillup')) {
          skillUpCourseProvider
            .deleteCoursePrerequisite({ courseId: this.$route.params.courseId, prerequisiteId: id })
            .then((res) => this.getData(this.handleCoursePrerequisites()))
        } else
          dadbanCourseProvider
            .deleteCoursePrerequisite({
              courseId: this.$route.params.courseId,
              prerequisiteId: id,
            })
            .then((res) => {
              this.getData(this.handleCoursePrerequisites())
            })
      }
      if (this.$route.name === 'package-prerequisites') {
        dadbanPackageProvider
          .deletePackagePrerequisite({
            packageId: this.$route.params.packageId,
            prerequisiteId: id,
          })
          .then((res) => {
            this.getData(this.handlePackagePrerequisites())
          })
      }

      if (this.$route.name === 'course-users') {
        const query = `?Id=${id}&ProductType=${this.$route.params.courseId ? 0 : 1}`
        if (this.$route.path.includes('university')) {
          moocUsersProvider.deleteCourseUser(query).then((res) => {
            this.getData(this.handleCourseUsers())
          })
        } else {
          skillUpUsersProvider.deleteCourseUser(query).then((res) => {
            this.getData(this.handleCourseUsers())
            this.$route.query.usersUpdate = 2
          })
        }
      }

      if (this.$route.name === 'courses-package') {
        if (this.$route.path.includes('skillup')) {
          skillUpPackageProvider.deletePackageCourse({ courseId: id, packageId: this.$route.params.packageId }).then((res) => {
            this.getData(this.handlePackegeCourses())
          })
        } else if (this.$route.path.includes('university')) {
          moocPackageProvider.deletePackageCourse({ courseId: id, packageId: this.$route.params.packageId }).then((res) => {
            this.getData(this.handlePackegeCourses())
          })
        } else {
          dadbanPackageProvider.deletePackageCourse(id).then((res) => {
            this.getData(this.handlePackegeCourses())
          })
        }
      }

      if (this.$route.path === '/list/homeslider') {
        skillUpBannerProvider.deleteBanner(id)
        setTimeout(() => {
          this.getData({ Key: 'homeslider' })
        }, 1000)
      }
      if (this.$route.path === '/list/skillupcertificates') {
        skillUpCertificateProvider.deleteCertificate(id)
        setTimeout(() => {
          this.getData({ Key: 'skillupcertificates' })
        }, 1000)
      }
    },
    updateData() {
      if (this.$route.name === 'course-prerequisites') {
        this.getData(this.handleCoursePrerequisites())
      }
      if (this.$route.name === 'package-prerequisites') {
        this.getData(this.handlePackagePrerequisites())
      }
      if (this.$route.name === 'courses-package') {
        this.getData(this.handlePackegeCourses())
      }
      if (this.$route.name === 'course-users') {
        this.getData(this.handleCourseUsers())
      }
      if (this.$route.name === 'courses-package-activities') {
        this.fetchAllActivities()
      }
    },
    handleSearchFocus() {
      this.focus = true
      if (this.$route.name === 'course-prerequisites') {
        if (this.$route.path.includes('skillup')) this.fetchSkillUpCoursePrerequisites()
        else this.fetchCoursePrerequisites()
      }
      if (this.$route.name === 'package-prerequisites') {
        this.fetchPackagePrerequisites()
      }
      if (this.$route.name === 'courses-package') {
        this.fetchCoursePackage()
      }
      if (this.$route.name === 'course-users') {
        this.fetchSearchUsers()
      }
    },
    async updateUserRole(e) {
      await skillUpCourseProvider.updateCourseUserRole(e)
      return false
    },
    updateUserSearch(value) {
      this.getData(this.handleCourseUsers(), value)
    },
  },
  computed: {
    routeParam() {
      if (this.$route.name === 'courses-package') {
        return 'skilluppackagecourses'
      }
      if (this.$route.name === 'courses-package-course-activities') {
        return 'activityorders'
      }
      if (this.$route.name === 'courses-package-activities') {
        return 'genenralactivityorders'
      }
      if (this.$route.params.courseId || this.$route.params.packageId) {
        return this.route.path
      }
      return this.$route.params.slug
    },
    route() {
      return this.$route
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.dataList.data.name,
          active: true,
        },
      ]
    },
    exceptionsRoute() {
      if (['/list/skillupcourses', '/list/skilluppackages'].includes(this.$route.path)) return true
      if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        return true
      }
      if (this.$route.name === 'course-prerequisites') {
        return true
      }
      if (this.$route.name === 'package-prerequisites') {
        return true
      }
      if (this.$route.name === 'course-users') {
        return true
      }
      if (this.$route.name === 'courses-package-course-activities') {
        return true
      }
      if (this.$route.name === 'courses-package-activities') {
        return true
      }
      if (this.$route.name.startsWith('comments')) {
        return true
      }
      if (this.$route.path.includes('agentskilluporders')) {
        return true
      }
      return false
    },
  },
  watch: {
    // $route(f) {
    //   console.log(f)
    //   if (f.path === '/list/totalcomments') {
    //     let queryParams = this.handleComments()
    //     setTimeout(() => {
    //       this.getData(queryParams)
    //     }, 1000)
    //   }
    // },
    '$route.query.query'(c) {
      if (this.$route.name === 'comments-courses') {
        let queryParams = this.handleCourseComments(this.$route)
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'comments-packages') {
        let queryParams = this.handlePackageComments(this.$route)
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'course-courseadminstudents' || this.$route.name === 'package-packageadminstudents') {
        let queryParams = this.handleStudent()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'courses-package') {
        let queryParams = this.handlePackegeCourses()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'course-prerequisites') {
        let queryParams = this.handleCoursePrerequisites()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'mooc-issuance-certificate') {
        let queryParams = this.handleIssuanceOfACertificate()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'skillUp-issuance-certificate') {
        let queryParams = this.handleSkillUpIssuanceOfACertificate()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'package-prerequisites') {
        let queryParams = this.handlePackagePrerequisites()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'course-users') {
        let queryParams = this.handleCourseUsers()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.path === '/list/discount') {
        let queryParams = this.handleDiscountList()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
        let queryParams = this.handleDiscountDetail()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'courses-package-activities') {
        setTimeout(() => {
          this.fetchAllActivities()
        }, 1000)
      } else if (this.$route.name === 'courses-package-course-activities') {
        setTimeout(() => {
          this.fetchCourseActivities()
        }, 1000)
      }
    },
    '$route.name'(c) {
      if (c === 'course-users') {
        const queryParams = this.handleCourseUsers()
        this.getData(queryParams)
        return false
      }
    },
    '$route.query.perPage'() {
      if (this.$route.name === 'course-users') {
        const queryParams = this.handleCourseUsers()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'courses-package-activities') {
        this.fetchAllActivities()
        return
      }
      if (this.$route.name === 'courses-package-course-activities') {
        this.fetchCourseActivities()
        return
      }
      // if (this.$route.path === '/list/totalcomments') {
      //   const queryParams = this.handleComments()
      //   this.getData(queryParams)
      //   return false
      // }
      if (this.$route.name === 'mooc-issuance-certificate') {
        const queryParams = this.handleIssuanceOfACertificate()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'skillUp-issuance-certificate') {
        const queryParams = this.handleSkillUpIssuanceOfACertificate()
        this.getData(queryParams)
        return false
      }

      if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
        let queryParams = this.handleDiscountDetail()
        setTimeout(() => {
          this.getData(queryParams)
          return false
        }, 1000)
      }

      if (this.$route.path === '/list/discount') {
        let queryParams = this.handleDiscountList()
        this.getData(queryParams)
        return false
      }
    },
    '$route.query.pageNumber'() {
      if (this.$route.name === 'course-users') {
        const queryParams = this.handleCourseUsers()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'courses-package-activities') {
        this.fetchAllActivities()
        return
      }
      if (this.$route.name === 'courses-package-course-activities') {
        this.fetchCourseActivities()
        return
      }
      if (this.$route.path === '/list/totalcomments') {
        const queryParams = this.handleComments()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'mooc-issuance-certificate') {
        const queryParams = this.handleIssuanceOfACertificate()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'skillUp-issuance-certificate') {
        const queryParams = this.handleSkillUpIssuanceOfACertificate()
        this.getData(queryParams)
        return false
      }

      if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
        let queryParams = this.handleDiscountDetail()
        setTimeout(() => {
          this.getData(queryParams)
          return false
        }, 1000)
      }

      if (this.$route.path === '/list/discount') {
        let queryParams = this.handleDiscountList()
        this.getData(queryParams)
        return false
      }
    },
    routeParam(newValue, oldValue) {
      this.prevRoute = `/list/${oldValue}`
      this.loading = true

      if (this.$route.name === 'comments-courses') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleCourseComments(this.$route)
        this.getData(queryParams)
      } else if (this.$route.name === 'comments-packages') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handlePackageComments(this.$route)
        this.getData(queryParams)
      } else if (this.$route.name === 'courses-package') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handlePackegeCourses()
        this.getData(queryParams)
      } else if (this.$route.name === 'course-courseadminstudents' || this.$route.name === 'package-packageadminstudents') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleStudent()
        this.getData(queryParams)
      } else if (this.$route.name === 'course-prerequisites') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleCoursePrerequisites()
        this.getData(queryParams)
      } else if (this.$route.name === 'package-prerequisites') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handlePackagePrerequisites()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/totalcomments') {
        let queryParams = this.handleComments()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'course-users') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleCourseUsers()
        this.getData(queryParams)
      } else if (this.$route.name === 'mooc-issuance-certificate') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleIssuanceOfACertificate()
        this.getData(queryParams)
      } else if (this.$route.name === 'skillUp-issuance-certificate') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleSkillUpIssuanceOfACertificate()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/discount') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleDiscountList()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleDiscountDetail()
        this.getData(queryParams)
      } else if (this.$route.name === 'courses-package-activities') {
        setTimeout(() => {
          this.fetchAllActivities()
        }, 1000)
        return
      } else if (this.$route.name === 'courses-package-course-activities') {
        setTimeout(() => {
          this.fetchCourseActivities()
        }, 1000)
        return
      } else if (newValue !== oldValue && this.$route.name !== 'transactions-fromListsWallet' && this.$route.name !== 'transactions-fromUserManagement') {
        let queryParams = {
          Key: newValue,
        }
        this.$store.dispatch('urlQueries/setSearchQuery', '')
        this.$store.dispatch('urlQueries/setCurrentPage', 1)
        this.$store.dispatch('urlQueries/setFields', [])
        this.$store.dispatch('urlQueries/setPageSize: ', 10)
        this.$store.dispatch('lists/setDataList', [])
        this.getData(queryParams)
      } else if (this.$route.name === 'transactions-fromListsWallet' || this.$route.name === 'transactions-fromUserManagement') {
        let queryParams = {
          Key: '',
          search: '',
          pageSize: 10,
          pageNumber: 1,
          fieldSearchs: [
            {
              fieldName: 'UserId',
              type: 'string',
              text: this.selectedRow.items.items[6].value,
            },
            {
              fieldName: 'Coin',
              type: 'string',
              text: this.selectedRow.items.items[7].value,
            },
          ],
        }
        this.getData(queryParams)
      }
    },
    wannaExcel(val) {
      if (val === true) {
        this.excelDownload()
      }
    },
  },

  mounted() {
    const route = this.$route
    let queryParams = null

    let ListsType = route.params.slug
    let query = route.query.query ? route.query.query : ''
    let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
    let pageSize = route.query.perPage ? route.query.perPage : 10
    let filters = route.query.filters ? route.query.filters : null
    this.$store.dispatch('urlQueries/setSearchQuery', query)
    this.$store.dispatch('urlQueries/setCurrentPage', pageNumber)
    this.$store.dispatch('urlQueries/setFields', filters)
    this.$store.dispatch('urlQueries/setPageSize', pageSize)

    if (route.name === 'courses-package-activities') {
      this.fetchAllActivities()
      return false
    }
    if (route.name === 'courses-package-course-activities') {
      this.fetchCourseActivities()
      return false
    }
    if (route.name === 'comments-courses') {
      queryParams = this.handleCourseComments(route)
      this.getData(queryParams)
      return false
    }

    if (route.name === 'comments-packages') {
      queryParams = this.handlePackageComments(route)
      this.getData(queryParams)
      return false
    }
    if (route.name === 'courses-package') {
      queryParams = this.handlePackegeCourses()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'course-courseadminstudents' || route.name === 'package-packageadminstudents') {
      queryParams = this.handleStudent()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'course-prerequisites') {
      queryParams = this.handleCoursePrerequisites()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/discount') {
      queryParams = this.handleDiscountList()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/totalcomments') {
      queryParams = this.handleComments()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/skillupdiscount/add' || route.path === '/list/skillupdiscount/detail/' + route.params.id) {
      queryParams = this.handleDiscountDetail()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'package-prerequisites') {
      queryParams = this.handlePackagePrerequisites()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'course-users') {
      queryParams = this.handleCourseUsers()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'mooc-issuance-certificate') {
      queryParams = this.handleIssuanceOfACertificate()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'skillUp-issuance-certificate') {
      queryParams = this.handleSkillUpIssuanceOfACertificate()
      this.getData(queryParams)
      return false
    }
    filters != undefined ? (filters = filters.split(',')) : []
    queryParams = {
      Key: ListsType,
      query: query,
      filters: filters,
      pageNumber: parseInt(pageNumber),
      pageSize: parseInt(pageSize),
    }

    this.getData(queryParams)
  },
  beforeDestroy() {
    this.$store.dispatch('lists/setDataList', [])
  },
}
</script>
<template>
  <div>
    <Toast v-if="!exceptionsRoute" :title="toastText" :error="toastMode" :showToast="showToast" :key="toastKey" />
    <div v-if="!loading">
      <PageHeader v-if="!exceptionsRoute" :title="dataList.data.name || ''" :items="headerItems" />
      <Reporting v-if="['universityreport', 'skillupreport'].includes($route.params.slug)" @onSearch="onSearch" />

      <div class="row" v-if="dataList.data.extra">
        <div class="col-3 mb-3" v-for="(card, idx) in dataList.data.extra.data" :key="idx">
          <div class="card">
            <div class="card-body py-3 px-2">
              <div class="extraMainDiv d-flex align-items-center justify-content-between">
                <div class>{{ dataList.data.extra.data[idx].title }}</div>
                <div class="descCard" data-bs-toggle="tooltip" :title="Commafy(dataList.data.extra.data[idx].description)" :style="`color:${dataList.data.extra.data[idx].color}`">
                  {{ Commafy(dataList.data.extra.data[idx].description) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IvitationSetting v-if="IvitationSettingModel" :key="modalKey" :earlyData="followUpData" />
      <div class="row">
        <BlackListModal v-if="BlackListModel" :key="BlackListKey" />
        <template v-if="this.route.name.startsWith('comments')">
          <CommentsSideCard :route="$route" />
        </template>
        <div class="col">
          <div v-if="!tableLoading">
            <div class="card">
              <div class="card-body p-card-body" :class="{ focused }">
                <TableHeader
                  v-if="
                    (dataList.data && dataList.data.addRowPage) ||
                    ['/list/discount/add', `/list/discount/detail/${$route.params.id}`].includes($route.path) ||
                    ['/list/skillupdiscount/add', `/list/skillupdiscount/detail/${$route.params.id}`].includes($route.path) ||
                    ['courses-package-activities', 'courses-package-course-activities'].includes($route.name)
                  "
                  :isActive="false"
                  searchVisible
                  :list="list"
                  :button="dataList.data.addRowPage && dataList.data.addRowPage.title && !$route.path.includes('/list/totalcomments') ? true : false"
                  :buttonTitle="dataList.data.addRowPage && dataList.data.addRowPage.title ? dataList.data.addRowPage.title : ''"
                  :buttonFunction="addRow"
                  actionClass="d-flex align-items-center justify-content-between"
                  :notDropdown="true"
                  :getData="getData"
                  @invitaionSetting="invitaionSetting($event)"
                  @blackList="blackListSetting"
                  @focused="handleSearchFocus"
                  @update="updateData"
                  :settingBtn="dataList.data.addRowPage && dataList.data.addRowPage.key === 'invitation' ? true : false"
                />

                <Table
                  :key="componentKey"
                  :titleVisible="true"
                  :descriptionVisible="true"
                  :filterVisible="true"
                  :changeGrid="true"
                  :selectRoute="dataList.data.addRowPage && dataList.data.addRowPage.link && `${dataList.data.addRowPage.link}/detail`"
                  :clickToChangeRoute="true"
                  :noNeedToChangeRoute="
                    !dataList.data.addRowPage ? true : dataList.data.addRowPage.link == null || (exceptionsRoute && !$route.name.startsWith('comments')) ? true : false
                  "
                  @deleteRow="deleteRow"
                  @updateRole="updateUserRole"
                  @updateUserSearch="updateUserSearch"
                  :title="dataList.name"
                  description="تست"
                  :selectOption="true"
                  hover="true"
                  :fields="fields"
                  :rows="rows"
                  @selected="(e) => $emit('selected', e)"
                  @selectedRow="rowSelected"
                  :checkedList="checkedList"
                >
                  <template v-slot:emptyTable>
                    <Loader :loading="dotLoading" />
                  </template>
                </Table>
                <Pagination :paginationData="dataList.pagination" :dropDownListItems="dropDownListItems" :getData="getData">
                  <template v-slot:excel>
                    <Excel :link="downloadLink" @downloadExcel="wannaExcel = $event" />
                  </template>
                </Pagination>
              </div>
            </div>
          </div>
          <Loader v-if="tableLoading" :loading="tableLoading" />
        </div>
      </div>
    </div>
    <Loader v-if="loading" :loading="loading" />
    <AddCategory :category="categoryData" @update="getData(handlePage())" />
    <Category :category="skillUPCategoryData" @update="getData(handlePage())" />
    <PartnerModal :partner="skillUpPartnerData" @update="getData(handlePage())" />
    <HomeCategoryModal :homeCategory="homeCategoryData" @update="getData(handleHomeCategory())" />
    <TeacherValidationModal />
    <SkillUpTeacherValidationModal />
  </div>
</template>

<style scoped>
@import url('./index.css');
</style>
